import { Navigate } from 'react-router-dom';
import TokenService from '../../services/authentication/TokenService';

export function RequireAuthentication({ children }) {
    let authToken = TokenService.getData();

    if (!authToken) {
        return <Navigate to="/home" replace />;
    }
    return children;
}
